<template>
  <div class="home">
    <home-headline />

    <home-content id="HomeContent" class="bg-color-a">
      <template v-slot:sidea>
        <h1 class="lg what-is-text">What is <span class="color-b">Meta DXi</span>?</h1>
        <div class="text-02">
          <br />
          It is a digital transformation data and information platform created by Meta for learning
          from the market and to be able to further support businesses in evolving their business
          models.
        </div>
      </template>
      <template v-slot:bar>
        <div class="bar desk">
          <img src="@/assets/img/home06.png" alt="" />
        </div>
        <div class="bar-horizontal mob">
          <img src="@/assets/img/home07.png" alt="" />
        </div>
      </template>
      <template v-slot:sideb>
        <div class="text-01">
          <b>“DX”</b> is an internationally used acronym for <b>“Digital Transformation”</b>and is
          presented by Meta as two small letters that simplify the term “digital transformation”
          while bringing cutting-edge technology content to the market. <br /><br />
          The “DX” is accompanied by an index (i) that aims to identify businesses’ digital
          maturity, in addition to being able to evolve together with the market - in an
          uncomplicated manner.
        </div>
      </template>

      <template v-slot:footer>
        <div class="about-footer-box">
          This survey is 100% exploratory. It does not reflect a market ranking. Its objective is to
          improve data and evolve together with the market in achieving digital maturity in
          companies. Please feel free to share your insights and tips with us!
        </div>
      </template>
    </home-content>

    <home-step />

    <home-content class="bg-color-c extra-margin who-is" id="HomeWhoIs">
      <template v-slot:fakeMobDiv>
        <div class="mob mob-fake-div">
          <a href="#HomeForm">
            <button class="cta-start-btn" role="button" @click="scrollToTop()">
              INICIAR PESQUISA
              <svg
                xmlns="http://www.w3.org/2000/svg"
                class="h-6 w-6 orange"
                fill="none"
                viewBox="0 0 24 24"
                stroke="currentColor"
              >
                <path
                  stroke-linecap="round"
                  stroke-linejoin="round"
                  stroke-width="2"
                  d="M9 5l7 7-7 7"
                />
              </svg>
            </button>
          </a>
        </div>
      </template>
      <template v-slot:sidea>
        <span class="lg"> Who is Meta? </span>
        <br /><br />
        <span class="who-is-meta-text">
          Meta is a digital transformation and technology solutions consultancy. The company has 30+
          years in the market and 2,500+ employees, and a global presence – there are 300 clients in
          8+ countries. Meta understands the importance of accelerating results to keep businesses
          relevant in an increasingly competitive market.
          <br /><br />
          Our company offers organizations customized solutions suited to different business models,
          segments, and industries worldwide, inspiring a cultural, agile and cognitive change, from
          end to end.
          <br /><br />
          This digital maturity generates revenue, reduces costs and, above all, values ​​people as
          the main capital in this transformation.
        </span>
      </template>
      <template v-slot:sideb>
        <img src="@/assets/img/home04.png" alt="" class="desk" />
        <img src="@/assets/img/home04-mob.png" alt="" class="mob" />
      </template>
    </home-content>

    <home-solutions />

    <Footer />

    <div class="scrollToTop" @click="scrollToTop()" v-show="showScroll">
      <svg
        xmlns="http://www.w3.org/2000/svg"
        class="h-6 w-6"
        fill="none"
        viewBox="0 0 24 24"
        stroke="currentColor"
      >
        <path stroke-linecap="round" stroke-linejoin="round" stroke-width="2" d="M5 15l7-7 7 7" />
      </svg>
    </div>

    <contact-us />
  </div>
</template>

<script>
import HomeHeader from "@/components/Home/HomeHeader";
import HomeHeadline from "../components/Home/HomeHeadline.vue";
import HomeContent from "../components/Home/HomeContent.vue";
import HomeStep from "../components/Home/HomeStep.vue";
import ContactUs from "../components/ContactUs/Form.vue";
import HomeSolutions from "../components/Home/HomeSolutions.vue";
import Footer from "@/components/Parts/Footer";

export default {
  name: "Home",
  components: {
    HomeHeader,
    HomeHeadline,
    Footer,
    ContactUs,
    HomeContent,
    HomeSolutions,
    HomeStep,
  },
  data: () => ({
    showScroll: false,
  }),
  methods: {
    findPos(obj) {
      var curtop = 0;
      if (obj.offsetParent) {
        do {
          curtop += obj.offsetTop;
        } while ((obj = obj.offsetParent));
        return [curtop];
      }
    },
    scrollTo(element) {
      document.querySelector(element).scrollIntoView({
        behavior: "smooth",
      });
    },
    scrollToTop() {
      window.scroll(0, this.findPos(document.getElementById("HomeForm")));
    },
    updateScroll() {
      this.scrollPosition = window.scrollY;

      this.showScroll = this.scrollPosition > 900;
    },
  },
  mounted() {
    window.addEventListener("scroll", this.updateScroll);
  },
};
</script>
